import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Construct from '@/pages/construct'
import General from '@/pages/general'
import Association from '@/pages/association'
import Policy from '@/pages/policy'
import Publicity from '@/pages/publicity'
import Notice from '@/pages/notice'
import Product from '@/pages/product'
import Exposure from '@/pages/exposure'
import Member from '@/pages/member'
import NewsDetail from '@/pages/newsDetail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index
    },
    {
      path: '/construct',
      component: Construct
    },
    {
      path: '/general',
      component: General
    },
    {
      path: '/association',
      component: Association
    },
    {
      path: '/policy',
      component: Policy
    },
    {
      path: '/publicity',
      component: Publicity
    },
    {
      path: '/notice',
      component: Notice
    },
    {
      path: '/product',
      component: Product
    },
    {
      path: '/exposure',
      component: Exposure
    },
    {
      path: '/member',
      component: Member
    },
    {
      path: '/news-detail',
      component: NewsDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js